import { Inbox, type LucideIcon } from "lucide-react";
import * as React from "react";

import { cn } from "../lib/cn";

export interface EmptyStateProps {
  /** Lucide icon rendered above the title. Defaults to an inbox glyph. */
  readonly icon?: LucideIcon;
  readonly title: string;
  readonly description?: string;
  /** Optional primary call to action, e.g. a `<Button>`. */
  readonly action?: React.ReactNode;
  readonly className?: string;
}

/** Neutral, zero-data placeholder for lists, panes, and tables. */
export function EmptyState({
  icon: Icon = Inbox,
  title,
  description,
  action,
  className,
}: EmptyStateProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
        className,
      )}
    >
      <span className="bg-muted text-muted-foreground flex size-12 items-center justify-center rounded-full">
        <Icon aria-hidden className="size-6" />
      </span>
      <div className="space-y-1">
        <p className="text-sm font-medium">{title}</p>
        {description !== undefined ? (
          <p className="text-muted-foreground max-w-sm text-sm text-balance">{description}</p>
        ) : null}
      </div>
      {action}
    </div>
  );
}
